window.onWizzyScriptLoaded = function () {
  document.getElementById("expandable-search").focus();

  changeTemplate("wizzy-search-results-product");
  changeTemplate("wizzy-search-results");
  changeTemplate("wizzy-search-pagination");
  changeTemplate("wizzy-common-select");
  changeTemplate("wizzy-search-empty-results");
        let showAll = false;

  if (window.innerWidth > 768) {
    changeTemplate("wizzy-autocomplete-topproducts");
    changeTemplate("wizzy-search-wrapper");

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
      function (data) {


document.querySelectorAll('.wizzy-filters-facet-block')
    .forEach(block => {
        block.addEventListener('click', () => {
            const facetList = block.querySelector('.wizzy-facet-list'); // Select the child element
            if (!facetList) return; // Skip if `.wizzy-facet-list` does not exist

            let currentMaxHeight = parseInt(window.getComputedStyle(facetList).maxHeight, 10) || 0; // Get current max-height
            const targetMaxHeight = block.classList.contains('collapsed') ? 500 : 0; // Target max-height
            const increment = targetMaxHeight > currentMaxHeight ? 10 : -10; // Increment or decrement value

            // block.classList.toggle('collapsed'); // Toggle the collapsed class

            const interval = setInterval(() => {
                currentMaxHeight += increment;

                // Apply max-height to the element
                facetList.style.maxHeight = `${currentMaxHeight}px`;

                // Stop the interval when the target max-height is reached
                if ((increment > 0 && currentMaxHeight >= targetMaxHeight) || (increment < 0 && currentMaxHeight <= targetMaxHeight)) {
                    clearInterval(interval);
                    facetList.style.maxHeight = `${targetMaxHeight}px`; // Ensure exact max-height at the end
                }
            }, 10); // Adjust interval time for smoother or faster animation
        });
    });














        const facetBlocks = document.querySelectorAll(
          ".wizzy-filters-facet-block"
        );
        facetBlocks.forEach((block, index) => {
          if (index < 5) {
            block.classList.add("visible");
          }
        });

        const dropdownButton = document.querySelector(".wizzy-dropdown");

        dropdownButton.addEventListener("click", () => {
          if (showAll) {
            // Add `visible` class only to the top 5 elements
            facetBlocks.forEach((block, index) => {
              block.classList.toggle("visible", index < 5);
             dropdownButton.textContent = "Show More Filters +"; // Update button text

            });
          } else {
            // Add `visible` class to all elements
            facetBlocks.forEach((block) => block.classList.add("visible"));
            dropdownButton.textContent = "Show Less Filters -"; // Update button text

          }
          // Toggle the state
          showAll = !showAll;
        });
        return data;
      }
    );
  }

  if (window.innerWidth < 768) {
    document.body.addEventListener("click", function (event) {
      if (event.target.closest(".wizzy-sort-container")) {
        document.body.classList.add("wizzy-bg");
      }
      if (
        event.target.closest(".wizzy-common-select-overlay") ||
        event.target.closest(".wizzy-common-select-options")
      ) {
        //console.log(event.target);
        document.body.classList.remove("wizzy-bg");
      }
    });

    // Select the target element

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
      function (data) {
        const targetNode = document.querySelector(
          ".wizzy-autocomplete-wrapper"
        );

        if (targetNode) {
          const computedStyle = window.getComputedStyle(targetNode);

          if (computedStyle.display === "flex") {
            document.body.classList.add("wizzy-fixed-height");
            document.documentElement.classList.add("wizzy-fixed-height");
          }
        }

        //console.log(targetNode,"tttttttttttt")
        // Options for the observer (which mutations to observe)
        const config = {
          attributes: true,
          attributeFilter: ["style"],
        };
        const callback = function (mutationsList, observer) {
          for (const mutation of mutationsList) {
            if (
              mutation.type === "attributes" &&
              mutation.attributeName === "style"
            ) {
              const display = window.getComputedStyle(mutation.target).display;
              //console.log(display);
              if (display === "flex") {
                document.body.classList.add("wizzy-fixed-height");
                document.documentElement.classList.add("wizzy-fixed-height");
              } else {
                document.body.classList.remove("wizzy-fixed-height");
                document.documentElement.classList.remove("wizzy-fixed-height");
              }
            }
          }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
        return data;
      }
    );
  }

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      //console.log(payload,"wizzy")
      payload.common.lazyDOMConfig.contentDOMIdentifiers.push("#main");
      payload.filters.configs.keepOpenedInMobileAfterApply = true;
      payload.filters.configs.displayAsDrawer = false;
      return payload;
    }
  );

  const labelMap = {
    "MARKS SIGNATURE [MALO]": "Marks Signature",
    "Marks Estate Dept 1": "ReMARKable Estate",
    "Marks Estate Dept 2": "ReMARKable Estate",
    "Marks Estate Department 1": "ReMARKable Estate",
    "Marks Estate Department 2": "ReMARKable Estate",
    "Alpha Labgrown Diamonds": "PureMark",
    "ALTR Puremark Laboratory Grown": "PureMark",
    "ReMARKable Product": "ReMARKable Designs",
    "DIALOG SOLUTIONS INC": "ReMARKable Designs",
    "AANYA": "ReMARKable Designs",
    "Adwar Casting": "ReMARKable Designs",
    "AFFINITY DESIGNS LLC": "ReMARKable Designs",
    "Allison Kaufman": "ReMARKable Designs",
    "Amden Jewelry": "ReMARKable Designs",
    "Amrus Jewelry": "ReMARKable Designs",
    "Andrea Candela": "ReMARKable Designs",
    "Artcarved": "ReMARKable Designs",
    "Ashi Diamonds, LLC": "ReMARKable Designs",
    "AZUL PARTNERS LLC": "ReMARKable Designs",
    "Barry Davidson, Inc.": "ReMARKable Designs",
    "BELLARRI": "ReMARKable Designs",
    "Bliss Manufacturing": "ReMARKable Designs",
    "China Pearl": "ReMARKable Designs",
    "Cool And Interesting": "ReMARKable Designs",
    "Coronation cultured pearls": "ReMARKable Designs",
    "D & A Bassali, Corp.": "ReMARKable Designs",
    "Dalumi Diamond Corporation": "ReMARKable Designs",
    "DASSARI": "ReMARKable Designs",
    "David Kord (Formerly A & D)": "ReMARKable Designs",
    "David Rovinsky": "ReMARKable Designs",
    "DeLatori": "ReMARKable Designs",
    "Diamonds are Forever Dani Aslan": "ReMARKable Designs",
    "Diamonds Forever of USA, Inc.": "ReMARKable Designs",
    "Diamondsone": "ReMARKable Designs",
    "Divine LLC": "ReMARKable Designs",
    "DORA INTERNATIONAL, INC": "ReMARKable Designs",
    "Ear Studs USA": "ReMARKable Designs",
    "EMA Jewelry": "ReMARKable Designs",
    "Equity Diamond Brokers": "ReMARKable Designs",
    "First Image Design Corp./Roman and Jules": "ReMARKable Designs",
    "First Impressions- Custom Goldsmithing, Inc.": "ReMARKable Designs",
    "Fischer Jewelry Designs": "ReMARKable Designs",
    "Frederick Goldman": "ReMARKable Designs",
    "Gabriel  & Co.": "ReMARKable Designs",
    "Gemsone corporation": "ReMARKable Designs",
    "GIFT - Felix Z": "ReMARKable Designs",
    "GIFT - Kenro Industries Pininfarina": "ReMARKable Designs",
    "GIFT Bronzeallure (Milanesi And Co LTD)": "ReMARKable Designs",
    "GIFT Classic of New York": "ReMARKable Designs",
    "GIFT Frederic Duclos": "ReMARKable Designs",
    "GIFT Jayden Star LLC": "ReMARKable Designs",
    "GIFT Jimmy Crystal New York": "ReMARKable Designs",
    "GIFT Moon & Lola": "ReMARKable Designs",
    "GIFT Picnic Time": "ReMARKable Designs",
    "GIFT Savvy Designs": "ReMARKable Designs",
    "GIFT True Brands": "ReMARKable Designs",
    "GIFT Two's Company Inc.": "ReMARKable Designs",
    "GIFT Wild and Wolf": "ReMARKable Designs",
    "GIFT WOLF DESIGNSIC": "ReMARKable Designs",
    "GIFT Zsa Zsa Jewels": "ReMARKable Designs",
    "GN Diamonds": "ReMARKable Designs",
    "Henderson Collection by Lecil": "ReMARKable Designs",
    "HERCO": "ReMARKable Designs",
    "I. Reiss Company": "ReMARKable Designs",
    "Interings Inc.": "ReMARKable Designs",
    "International Diamond Distributors": "ReMARKable Designs",
    "Jewelry Design Showcase": "ReMARKable Designs",
    "JewlVision": "ReMARKable Designs",
    "Jim - CAD Design": "ReMARKable Designs",
    "JOCALIO GROUP LLC": "ReMARKable Designs",
    "Joshua J. Fine Jewelry": "ReMARKable Designs",
    "Judith Jack": "ReMARKable Designs",
    "K.P. Sanghvi Inc.": "ReMARKable Designs",
    "Kat Designs": "ReMARKable Designs",
    "Leslies": "ReMARKable Designs",
    "Lieberfarb, Inc.": "ReMARKable Designs",
    "M.K. Diamonds & Jewelry": "ReMARKable Designs",
    "Malakan Diamond Company": "ReMARKable Designs",
    "Marathon Company": "ReMARKable Designs",
    "Marks Jewelers": "ReMARKable Designs",
    "Marks Jewelers Levittown": "ReMARKable Designs",
    "Marks Jewelers Montgomeryville": "ReMARKable Designs",
    "Marks Swiss (Belair)": "ReMARKable Designs",
    "Mastoloni": "ReMARKable Designs",
    "MAXMARK, INC.": "ReMARKable Designs",
    "Mercury Ring": "ReMARKable Designs",
    "Metal Market Intl": "ReMARKable Designs",
    "Midas Chain": "ReMARKable Designs",
    "MIREL DESIGNS INC": "ReMARKable Designs",
    "Name and Design": "ReMARKable Designs",
    "Nemorofsky": "ReMARKable Designs",
    "Nina Nguyen": "ReMARKable Designs",
    "Ninacci, Inc.": "ReMARKable Designs",
    "OFF THE STREET - HEADQUARTERS - MONTGOMERYVILLE PA": "ReMARKable Designs",
    "OVERNIGHT MOUNTINGS": "ReMARKable Designs",
    "Pandora Jewelry": "ReMARKable Designs",
    "Paramount Gems": "ReMARKable Designs",
    "Pink Diamond": "ReMARKable Designs",
    "Price Point Marketing": "ReMARKable Designs",
    "Quality Gold": "ReMARKable Designs",
    "R.A. Riam Group Inc.": "ReMARKable Designs",
    "REVV - JMC": "ReMARKable Designs",
    "Royal Jewelry Manufacturing Inc.": "ReMARKable Designs",
    "Rubinoff Jewelry": "ReMARKable Designs",
    "S&R Designs": "ReMARKable Designs",
    "S. KASHI": "ReMARKable Designs",
    "Sam Hakimi Gem": "ReMARKable Designs",
    "Sandberg & Sikorsk": "ReMARKable Designs",
    "Scott Kay": "ReMARKable Designs",
    "SDC Creations": "ReMARKable Designs",
    "Siffari": "ReMARKable Designs",
    "Sophia By Design": "ReMARKable Designs",
    "SPARKLE GEMS": "ReMARKable Designs",
    "Speidel Inc.": "ReMARKable Designs",
    "Stock Jewlvision - Made in Montgomeryville": "ReMARKable Designs",
    "Stuller": "ReMARKable Designs",
    "Tache Jewelry": "ReMARKable Designs",
    "TF - Kenro Industries": "ReMARKable Designs",
    "The Bracelet Authority": "ReMARKable Designs",
    "Timeless Designs": "ReMARKable Designs",
    "True Romance": "ReMARKable Designs",
    "Universal Pacific Diamonds": "ReMARKable Designs",
    "Venetti": "ReMARKable Designs",
    "VIANNA BRASIL": "ReMARKable Designs",
    "VIMCO DIAMOND CORP.": "ReMARKable Designs",
    "Wilkerson": "ReMARKable Designs",
    "Yerushalmi Brothers": "ReMARKable Designs",
    "Zeghani": "ReMARKable Designs",
  };

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      data.forEach((product) => {
        let attributes = product.attributes;
        attributes.forEach((attribute) => {
          if (attribute.id === "product_vendor") {
            const value = attribute.values[0].value[0];

            // Use the map to find the corresponding new label, or fallback to the original value if not present
            product.vendor = labelMap[value] || value;
          }
        });
      });
      return data;
    }
  );

  document.body.addEventListener("click", function (event) {
    if (
      event.target.matches(".wizzy-facet-head") ||
      event.target.matches(".facet-head-title")
    ) {
      // Find the closest ancestor with the class .wizzy-filters-facet-block.facet-block-top
      const closestBlock = event.target.closest(
        ".wizzy-filters-facet-block.facet-block-top"
      );
      if (closestBlock) {
        let left = closestBlock.offsetLeft;
        document
          .querySelectorAll(".wizzy-facet-list")
          .forEach(function (element) {
            element.style.left = left - 25 + "px";
          });
      }
    }
  });

  document.body.addEventListener("click", function (event) {
    if (event.target.closest(".wizzy-common-select-selector")) {
      document.querySelector(".wizzy-filters-bg").style.display = "none";
    }
  });
};

const changeTemplate = function (div) {
  const oldDiv = document.getElementById(div);
  const newDiv = document.getElementById(div + "-new").text;

  oldDiv.text = newDiv;
};
